import art from "../../assets/images/art.png";
import validator from "../../assets/images/validator.png";
import todo from "../../assets/images/todo.png";
import stokveel from "../../assets/images/stokveel.png";
import reiq from "../../assets/images/r3.jpg";
import { FaCircle, FaExternalLinkAlt } from "react-icons/fa";
import { Link } from "react-router-dom";

export default function ApiValidator() {
  return (
    <div className="w-full h-full flex md:p-10">
      <div
        className="relative md:py-10 w-full rounded-lg md:px-40 "
        style={{
          backgroundImage: `url(${validator})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="absolute inset-0 bg-black/50 rounded-lg " />
        <div className="bg-black/60 rounded-lg shadow-2xl h-full grid md:grid-cols-3 relative">
          <div className="relative flex pb-5 items-center justify-center">
            <div className="md:absolute w-[18rem] md:-left-[7.5rem] md:top-1/2 md:-translate-y-1/2 flex flex-col md:items-start">
              <img src={validator} className="md:h-70 w-full rounded-lg" />
              <div className=" items-center justify-center w-full mt-4 flex gap-10">
                <Link
                  to={"https://github.com/23Mandla/ApiValidator"}
                  target="blank"
                  className="border flex items-center gap-2 py-[2px] text-sm px-6 rounded-full"
                >
                  <p>Git</p> <FaExternalLinkAlt className="text-[8px]" />
                </Link>
                <Link to={"https://main.dai17y7gqfc5d.amplifyapp.com/"} target="blank" className="border text-sm px-3 py-[2px] rounded-full flex items-center gap-2">
                  <FaCircle className="text-[8px] text-green-500" />
                  <p>Live</p>
                </Link>
              </div>
            </div>
          </div>
          <div className="md:col-span-2 order-first md:order-none flex gap-5 flex-col md:px-16 sm:px-10 p-5 justify-center ">
            <div className="w-full">
              <h1 className="md:text-xl sm:text-md text-xs font-bold">Api Validation</h1>
            </div>
            <div className="">
              <p className="md:text-sm text-xs">
                Instantly validate and test your URL. The tool calls a cloud
                function via API Gateway, processes your request, and returns a
                sorted, ordered list of characters.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
